// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeBlog_main_container{
    height: 850px;
    color: #0F0F0F;
}

.HomeBlog_head_container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 100px 0;
}

.HomeBlog_headh3{
    font-weight: 700;
    font-size: 36px;
    line-height: 55px;
}

.HomeBlog_headp{
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    width: 633px;
    height: 72px;
    text-align: center;
}

.HomeBlog_gallery_container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
}
.homeBlog_gallery_content{
    display: grid;
    grid-template-columns: repeat(3,1fr);
    justify-content: center;
    align-items: center;
    gap: 30px;
}

.HomeBlog_img1_container{
    position: relative;
}

.HomeBlog_img1_container img{
    border-radius: 15px;
    width: 380px;
    height: 200px;
    object-fit: cover;
}

.HomeBlog_btn{
    width: 81px;
    height: 27px;
    padding: 4px 10px 4px 10px;
    border-radius: 8px;
    background-color: #5CBF14;
    text-align: center;
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    justify-content: flex-end;
}

.HomeBlog_btnp{
    font-weight: 400;
    font-size: 12px;
    line-height: 18.44px;
    color: #FFFFFF;
}

.HomeBlog_card_container,.HomeBlog_card_container2{
    height: 202px;
    width: 380px;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
    border-radius: 15px;
    padding: 20px ;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    top: -30px;
    background-color: #FFFFFF;
}


.HomeBlog_card_text1{
    font-family: Helvetica;
    font-weight: 400;
    font-size: 12px;
    line-height: 18.44px;
    color: #808080;
}

.HomeBlog_card_texth6{
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    width: 340px;
    height: 60px;
    color: #000000;
}

.HomeBlog_card_text2{
    font-weight: 700;
    font-size: 12.54px;
    line-height: 18.44px;
    color: #000000;
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.HomeBlog_card_text2span,.HomeBlog_card_text2span a{
    font-weight: 700;
    font-size: 12.544px;
    line-height: 18.44px;
    color: #D40E1F;
}

.view_more_btn {
    margin-top: 25px;
}

.view_more_btn a{
    border-radius: 25px;
    background: #5CBF14;
    color: #FFF;
    font-size: 16px;
    font-weight: 400;
    padding: 14px 64px;
}




@media screen and (max-width: 1050px){

    .HomeBlog_headh3{
        font-size: 32px;
    }
    
    .HomeBlog_headp{
        font-size: 18px;
        width: 550px;
    }
    
    
    .HomeBlog_img1_container{
        position: relative;
    }
    
    .HomeBlog_img1_container img{
        border-radius: 15px;
        width: 300px;
    }
    
    .HomeBlog_btn{
        width: 81px;
        height: 27px;
        padding: 4px 10px 4px 10px;
        border-radius: 8px;
        background-color: #5CBF14;
        text-align: center;
        position: absolute;
        top: 10px;
        right: 10px;
        display: flex;
        justify-content: flex-end;
    }
    
    .HomeBlog_btnp{
        font-weight: 400;
        font-size: 12px;
        line-height: 18.44px;
        color: #FFFFFF;
    }
    
    .HomeBlog_card_container, .HomeBlog_card_container2{
        height: 202px;
        width: 300px;
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
        border-radius: 15px;
        /* padding: 20px ; */
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        top: -30px;
        background-color: #FFFFFF;
    }
    
    .HomeBlog_card_text1{
        font-family: Helvetica;
        font-weight: 400;
        font-size: 12px;
        line-height: 18.44px;
        color: #808080;
    }
    
    .HomeBlog_card_texth6{
        font-weight: 700;
        font-size: 15px;
        line-height: 20px;
        width: 270px;
        height: 60px;
    }
    
    .HomeBlog_card_text2{
        font-weight: 700;
        font-size: 11.54px;
        line-height: 18.44px;
        color: #000000;
    }
    
    .HomeBlog_card_text2span{
        font-weight: 400;
        font-size: 13.34px;
        line-height: 18.44px;
        color: #D40E1F;
    }
}


@media screen and (max-width: 900px){

    .HomeBlog_main_container{
        height: 1300px;
        color: #0F0F0F;
    }
    .HomeBlog_headh3{
        font-size: 30px;
    }
    
    .HomeBlog_headp{
        font-size: 16px;
        width: 500px;
    }
    
    .homeBlog_gallery_content{
        display: grid;
        grid-template-columns: repeat(2,1fr);
        justify-content: center;
        align-items: center;
        gap: 30px;
    }
    
    
    .HomeBlog_img1_container img{
        border-radius: 15px;
        width: 300px;
    }
    
    .HomeBlog_btn{
        width: 71px;
        height: 24px;
        padding: 4px 10px 4px 10px;
        border-radius: 8px;
        background-color: #5CBF14;
        text-align: center;
        position: absolute;
        top: 10px;
        right: 10px;
        display: flex;
        justify-content: flex-end;
    }
    
    .HomeBlog_btnp{
        font-weight: 400;
        font-size: 11px;
        line-height: 17.44px;
        color: #FFFFFF;
    }
    
    .HomeBlog_card_container, .HomeBlog_card_container2{
        height: 202px;
        width: 300px;
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
        border-radius: 15px;
        /* padding: 20px ; */
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        top: -30px;
        background-color: #FFFFFF;
    }
    
    .HomeBlog_card_text1{
        font-family: Helvetica;
        font-weight: 400;
        font-size: 11px;
        line-height: 18.44px;
        color: #808080;
    }
    
    .HomeBlog_card_texth6{
        font-weight: 700;
        font-size: 12px;
        line-height: 18px;
        width: 180px;
        height: 60px;
    }
    
    .HomeBlog_card_text2{
        font-weight: 700;
        font-size: 9.54px;
        line-height: 17.44px;
        color: #000000;
    }
    
    .HomeBlog_card_text2span{
        font-weight: 600;
        font-size: 10.34px;
        line-height: 17.44px;
        color: #D40E1F;
    }
}


@media screen and (max-width: 500px){
    .HomeBlog_main_container{
        height: 1650px;
        color: #0F0F0F;
        padding: 0 20px;
    }
    
    .HomeBlog_head_container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 40px 0 80px 0;
    }
    
    .HomeBlog_headh3{
        font-weight: 700;
        font-size: 24px;
        line-height: 55px;
    }
    
    .HomeBlog_headp{
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        width: 338px;
        text-align: center;
    }

    .HomeBlog_gallery_container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center; 

    }

    .homeBlog_gallery_content{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 30px;
        /* position: relative; */
    }

    .HomeBlog_gallery1{
        width: 100%;
    }
    

    .HomeBlog_img1_container img{
        border-radius: 15px;
        /* width: 100%; */
        height: 200px;
        object-fit: cover;
    }

    .HomeBlog_card_container,.HomeBlog_card_container2{
        height: 220px;
        /* width: 100%; */
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
        border-radius: 15px;
        /* padding: 20px ; */
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        top: -30px;
        background-color: #FFFFFF;
    }
    
    .HomeBlog_card_text1{
        font-family: Helvetica;
        font-weight: 400;
        font-size: 12px;
        line-height: 18.44px;
        color: #808080;
    }
    
    .HomeBlog_card_texth6{
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;
        width: 100%;
        height: 60px;
    }
    
    .HomeBlog_card_text2{
        font-weight: 700;
        font-size: 12.54px;
        line-height: 18.44px;
        color: #000000;
    }
    
    .HomeBlog_card_text2span{
        font-weight: 400;
        font-size: 14.34px;
        line-height: 18.44px;
        color: #D40E1F;
    }


}

@media screen and (max-width: 400px){

    .HomeBlog_main_container{
        color: #0F0F0F;
    }
    
    .HomeBlog_headh3{
        font-size: 23px;
    }
    
    .HomeBlog_headp{
        font-size: 15px;
        width: 328px;
    }

    .HomeBlog_card_text1{
        font-family: Helvetica;
        font-weight: 400;
        font-size: 12px;
        line-height: 18.44px;
        color: #808080;
    }
    
    .HomeBlog_card_texth6{
        font-weight: 700;
        font-size: 15px;
        line-height: 20px;
        width: 100%;
        height: 60px;
    }
    
    .HomeBlog_card_text2{
        font-weight: 700;
        font-size: 11.54px;
        line-height: 18.44px;
        color: #000000;
    }
    
    .HomeBlog_card_text2span{
        font-weight: 400;
        font-size: 13.34px;
        line-height: 18.44px;
        color: #D40E1F;
    }


}

@media screen and (max-width: 330px){

    .HomeBlog_main_container{
        /* height: 1400px; */
        color: #0F0F0F;
    }
    
    .HomeBlog_headh3{
        font-size: 20px;
    }
    
    .HomeBlog_headp{
        font-size: 13px;
        width: 290px;
    }

    .HomeBlog_card_text1{
        font-family: Helvetica;
        font-weight: 400;
        font-size: 11px;
        line-height: 18.44px;
        color: #808080;
    }
    
    .HomeBlog_card_texth6{
        font-weight: 700;
        font-size: 12px;
        line-height: 18px;
        width: 100%;
        height: 60px;
    }
    
    .HomeBlog_card_text2{
        font-weight: 700;
        font-size: 9.54px;
        line-height: 17.44px;
        color: #000000;
    }
    
    .HomeBlog_card_text2span{
        font-weight: 600;
        font-size: 10.34px;
        line-height: 17.44px;
        color: #D40E1F;
    }

    



    


}`, "",{"version":3,"sources":["webpack://./src/styles/HomeBlog.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,aAAa;IACb,oCAAoC;IACpC,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,wCAAwC;IACxC,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,UAAU;IACV,yBAAyB;AAC7B;;;AAGA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;;;;AAKA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;;IAGA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,0BAA0B;QAC1B,kBAAkB;QAClB,yBAAyB;QACzB,kBAAkB;QAClB,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,aAAa;QACb,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,wCAAwC;QACxC,mBAAmB;QACnB,oBAAoB;QACpB,aAAa;QACb,sBAAsB;QACtB,8BAA8B;QAC9B,kBAAkB;QAClB,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;QACpB,cAAc;IAClB;AACJ;;;AAGA;;IAEI;QACI,cAAc;QACd,cAAc;IAClB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,oCAAoC;QACpC,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;IACb;;;IAGA;QACI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,0BAA0B;QAC1B,kBAAkB;QAClB,yBAAyB;QACzB,kBAAkB;QAClB,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,aAAa;QACb,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,wCAAwC;QACxC,mBAAmB;QACnB,oBAAoB;QACpB,aAAa;QACb,sBAAsB;QACtB,8BAA8B;QAC9B,kBAAkB;QAClB,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;QACpB,cAAc;IAClB;AACJ;;;AAGA;IACI;QACI,cAAc;QACd,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;;IAEvB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;QACT,wBAAwB;IAC5B;;IAEA;QACI,WAAW;IACf;;;IAGA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,wCAAwC;QACxC,mBAAmB;QACnB,oBAAoB;QACpB,aAAa;QACb,sBAAsB;QACtB,8BAA8B;QAC9B,kBAAkB;QAClB,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;QACpB,cAAc;IAClB;;;AAGJ;;AAEA;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;QACpB,cAAc;IAClB;;;AAGJ;;AAEA;;IAEI;QACI,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;QACpB,cAAc;IAClB;;;;;;;;;AASJ","sourcesContent":[".HomeBlog_main_container{\n    height: 850px;\n    color: #0F0F0F;\n}\n\n.HomeBlog_head_container{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 100px 0;\n}\n\n.HomeBlog_headh3{\n    font-weight: 700;\n    font-size: 36px;\n    line-height: 55px;\n}\n\n.HomeBlog_headp{\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 24px;\n    width: 633px;\n    height: 72px;\n    text-align: center;\n}\n\n.HomeBlog_gallery_container{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    \n}\n.homeBlog_gallery_content{\n    display: grid;\n    grid-template-columns: repeat(3,1fr);\n    justify-content: center;\n    align-items: center;\n    gap: 30px;\n}\n\n.HomeBlog_img1_container{\n    position: relative;\n}\n\n.HomeBlog_img1_container img{\n    border-radius: 15px;\n    width: 380px;\n    height: 200px;\n    object-fit: cover;\n}\n\n.HomeBlog_btn{\n    width: 81px;\n    height: 27px;\n    padding: 4px 10px 4px 10px;\n    border-radius: 8px;\n    background-color: #5CBF14;\n    text-align: center;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.HomeBlog_btnp{\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18.44px;\n    color: #FFFFFF;\n}\n\n.HomeBlog_card_container,.HomeBlog_card_container2{\n    height: 202px;\n    width: 380px;\n    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);\n    border-radius: 15px;\n    padding: 20px ;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    position: relative;\n    top: -30px;\n    background-color: #FFFFFF;\n}\n\n\n.HomeBlog_card_text1{\n    font-family: Helvetica;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18.44px;\n    color: #808080;\n}\n\n.HomeBlog_card_texth6{\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 20px;\n    width: 340px;\n    height: 60px;\n    color: #000000;\n}\n\n.HomeBlog_card_text2{\n    font-weight: 700;\n    font-size: 12.54px;\n    line-height: 18.44px;\n    color: #000000;\n    white-space: nowrap; \n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n}\n\n.HomeBlog_card_text2span,.HomeBlog_card_text2span a{\n    font-weight: 700;\n    font-size: 12.544px;\n    line-height: 18.44px;\n    color: #D40E1F;\n}\n\n.view_more_btn {\n    margin-top: 25px;\n}\n\n.view_more_btn a{\n    border-radius: 25px;\n    background: #5CBF14;\n    color: #FFF;\n    font-size: 16px;\n    font-weight: 400;\n    padding: 14px 64px;\n}\n\n\n\n\n@media screen and (max-width: 1050px){\n\n    .HomeBlog_headh3{\n        font-size: 32px;\n    }\n    \n    .HomeBlog_headp{\n        font-size: 18px;\n        width: 550px;\n    }\n    \n    \n    .HomeBlog_img1_container{\n        position: relative;\n    }\n    \n    .HomeBlog_img1_container img{\n        border-radius: 15px;\n        width: 300px;\n    }\n    \n    .HomeBlog_btn{\n        width: 81px;\n        height: 27px;\n        padding: 4px 10px 4px 10px;\n        border-radius: 8px;\n        background-color: #5CBF14;\n        text-align: center;\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        display: flex;\n        justify-content: flex-end;\n    }\n    \n    .HomeBlog_btnp{\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18.44px;\n        color: #FFFFFF;\n    }\n    \n    .HomeBlog_card_container, .HomeBlog_card_container2{\n        height: 202px;\n        width: 300px;\n        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);\n        border-radius: 15px;\n        /* padding: 20px ; */\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        position: relative;\n        top: -30px;\n        background-color: #FFFFFF;\n    }\n    \n    .HomeBlog_card_text1{\n        font-family: Helvetica;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18.44px;\n        color: #808080;\n    }\n    \n    .HomeBlog_card_texth6{\n        font-weight: 700;\n        font-size: 15px;\n        line-height: 20px;\n        width: 270px;\n        height: 60px;\n    }\n    \n    .HomeBlog_card_text2{\n        font-weight: 700;\n        font-size: 11.54px;\n        line-height: 18.44px;\n        color: #000000;\n    }\n    \n    .HomeBlog_card_text2span{\n        font-weight: 400;\n        font-size: 13.34px;\n        line-height: 18.44px;\n        color: #D40E1F;\n    }\n}\n\n\n@media screen and (max-width: 900px){\n\n    .HomeBlog_main_container{\n        height: 1300px;\n        color: #0F0F0F;\n    }\n    .HomeBlog_headh3{\n        font-size: 30px;\n    }\n    \n    .HomeBlog_headp{\n        font-size: 16px;\n        width: 500px;\n    }\n    \n    .homeBlog_gallery_content{\n        display: grid;\n        grid-template-columns: repeat(2,1fr);\n        justify-content: center;\n        align-items: center;\n        gap: 30px;\n    }\n    \n    \n    .HomeBlog_img1_container img{\n        border-radius: 15px;\n        width: 300px;\n    }\n    \n    .HomeBlog_btn{\n        width: 71px;\n        height: 24px;\n        padding: 4px 10px 4px 10px;\n        border-radius: 8px;\n        background-color: #5CBF14;\n        text-align: center;\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        display: flex;\n        justify-content: flex-end;\n    }\n    \n    .HomeBlog_btnp{\n        font-weight: 400;\n        font-size: 11px;\n        line-height: 17.44px;\n        color: #FFFFFF;\n    }\n    \n    .HomeBlog_card_container, .HomeBlog_card_container2{\n        height: 202px;\n        width: 300px;\n        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);\n        border-radius: 15px;\n        /* padding: 20px ; */\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        position: relative;\n        top: -30px;\n        background-color: #FFFFFF;\n    }\n    \n    .HomeBlog_card_text1{\n        font-family: Helvetica;\n        font-weight: 400;\n        font-size: 11px;\n        line-height: 18.44px;\n        color: #808080;\n    }\n    \n    .HomeBlog_card_texth6{\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 18px;\n        width: 180px;\n        height: 60px;\n    }\n    \n    .HomeBlog_card_text2{\n        font-weight: 700;\n        font-size: 9.54px;\n        line-height: 17.44px;\n        color: #000000;\n    }\n    \n    .HomeBlog_card_text2span{\n        font-weight: 600;\n        font-size: 10.34px;\n        line-height: 17.44px;\n        color: #D40E1F;\n    }\n}\n\n\n@media screen and (max-width: 500px){\n    .HomeBlog_main_container{\n        height: 1650px;\n        color: #0F0F0F;\n        padding: 0 20px;\n    }\n    \n    .HomeBlog_head_container{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        padding: 40px 0 80px 0;\n    }\n    \n    .HomeBlog_headh3{\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 55px;\n    }\n    \n    .HomeBlog_headp{\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        width: 338px;\n        text-align: center;\n    }\n\n    .HomeBlog_gallery_container{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center; \n\n    }\n\n    .homeBlog_gallery_content{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 30px;\n        /* position: relative; */\n    }\n\n    .HomeBlog_gallery1{\n        width: 100%;\n    }\n    \n\n    .HomeBlog_img1_container img{\n        border-radius: 15px;\n        /* width: 100%; */\n        height: 200px;\n        object-fit: cover;\n    }\n\n    .HomeBlog_card_container,.HomeBlog_card_container2{\n        height: 220px;\n        /* width: 100%; */\n        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);\n        border-radius: 15px;\n        /* padding: 20px ; */\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        position: relative;\n        top: -30px;\n        background-color: #FFFFFF;\n    }\n    \n    .HomeBlog_card_text1{\n        font-family: Helvetica;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18.44px;\n        color: #808080;\n    }\n    \n    .HomeBlog_card_texth6{\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 20px;\n        width: 100%;\n        height: 60px;\n    }\n    \n    .HomeBlog_card_text2{\n        font-weight: 700;\n        font-size: 12.54px;\n        line-height: 18.44px;\n        color: #000000;\n    }\n    \n    .HomeBlog_card_text2span{\n        font-weight: 400;\n        font-size: 14.34px;\n        line-height: 18.44px;\n        color: #D40E1F;\n    }\n\n\n}\n\n@media screen and (max-width: 400px){\n\n    .HomeBlog_main_container{\n        color: #0F0F0F;\n    }\n    \n    .HomeBlog_headh3{\n        font-size: 23px;\n    }\n    \n    .HomeBlog_headp{\n        font-size: 15px;\n        width: 328px;\n    }\n\n    .HomeBlog_card_text1{\n        font-family: Helvetica;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18.44px;\n        color: #808080;\n    }\n    \n    .HomeBlog_card_texth6{\n        font-weight: 700;\n        font-size: 15px;\n        line-height: 20px;\n        width: 100%;\n        height: 60px;\n    }\n    \n    .HomeBlog_card_text2{\n        font-weight: 700;\n        font-size: 11.54px;\n        line-height: 18.44px;\n        color: #000000;\n    }\n    \n    .HomeBlog_card_text2span{\n        font-weight: 400;\n        font-size: 13.34px;\n        line-height: 18.44px;\n        color: #D40E1F;\n    }\n\n\n}\n\n@media screen and (max-width: 330px){\n\n    .HomeBlog_main_container{\n        /* height: 1400px; */\n        color: #0F0F0F;\n    }\n    \n    .HomeBlog_headh3{\n        font-size: 20px;\n    }\n    \n    .HomeBlog_headp{\n        font-size: 13px;\n        width: 290px;\n    }\n\n    .HomeBlog_card_text1{\n        font-family: Helvetica;\n        font-weight: 400;\n        font-size: 11px;\n        line-height: 18.44px;\n        color: #808080;\n    }\n    \n    .HomeBlog_card_texth6{\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 18px;\n        width: 100%;\n        height: 60px;\n    }\n    \n    .HomeBlog_card_text2{\n        font-weight: 700;\n        font-size: 9.54px;\n        line-height: 17.44px;\n        color: #000000;\n    }\n    \n    .HomeBlog_card_text2span{\n        font-weight: 600;\n        font-size: 10.34px;\n        line-height: 17.44px;\n        color: #D40E1F;\n    }\n\n    \n\n\n\n    \n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
